import { createContext, useContext, type ReactNode } from "react";
// 直接具体路径，避免 contexts → components/Event/hooks/index → 各 business hook → contexts 的长环
import { useFloatingIcons } from "../components/Event/hooks/useFloatingIcons";

type FloatingIconsContextValue = ReturnType<typeof useFloatingIcons>;

const FloatingIconsContext = createContext<FloatingIconsContextValue | null>(
  null
);

export const FloatingIconsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const value = useFloatingIcons();
  return (
    <FloatingIconsContext.Provider value={value}>
      {children}
    </FloatingIconsContext.Provider>
  );
};

export const useFloatingIconsContext = (): FloatingIconsContextValue => {
  const ctx = useContext(FloatingIconsContext);
  if (!ctx) {
    console.warn(
      "[useFloatingIconsContext] used outside FloatingIconsProvider, returning empty fallback"
    );
    return {
      floatingIcons: [],
      leftBottomFloatingIcons: [],
      PopupRegistrationComponent: () => null,
    } as unknown as FloatingIconsContextValue;
  }
  return ctx;
};
